import React from 'react';
import { useTranslation } from '../../lib/i18n';

// Single source of truth for the site-wide "last updated" date.
export const LAST_UPDATED = {
  sr: '24. avgust 2026.',
  en: 'August 24, 2026',
  ru: '24 августа 2026 г.'
};
export function LastUpdated() {
  const {
    lang
  } = useTranslation();
  const label = lang === 'en' ? 'Last updated: ' : lang === 'ru' ? 'Последнее обновление: ' : 'Poslednje ažuriranje: ';
  return <p className="mt-10 border-t border-dark-border pt-6 text-sm text-gray-500" data-id="element-629" data-mp="3dkz9cbofhfm9">
      {label}
      {LAST_UPDATED[lang]}
    </p>;
}